<template>
  <div class="tw-flex">
    <div v-show="association === 'project'" class="tw-flex-grow tw-mr-4">
      <div
        class="radio input-btn"
        :class="{
          selected: internalModelValue === 'fixed',
          unselected: internalModelValue !== 'fixed',
        }"
      >
        <label>
          <input v-model="internalModelValue" type="radio" name="ratetype" value="fixed" />
          <i class="input-helper"></i>
          {{ $t('Fixed budget') }}
        </label>
      </div>
    </div>

    <div class="tw-flex-grow tw-mr-4">
      <div
        class="radio input-btn"
        :class="{
          selected: internalModelValue === 'hourly',
          unselected: internalModelValue !== 'hourly',
        }"
      >
        <label>
          <input v-model="internalModelValue" type="radio" name="ratetype" value="hourly" />
          <i class="input-helper"></i>
          {{ $t('Per hour') }}
        </label>
      </div>
    </div>

    <div class="tw-flex-grow tw-mr-4">
      <div
        class="radio input-btn"
        :class="{
          selected: internalModelValue === 'daily',
          unselected: internalModelValue !== 'daily',
        }"
      >
        <label>
          <input v-model="internalModelValue" type="radio" name="ratetype" value="daily" />
          <i class="input-helper"></i>
          {{ $t('Per day') }}
        </label>
      </div>
    </div>

    <div v-show="association !== 'project'" class="tw-flex-grow tw-mr-4">
      <div
        class="radio input-btn"
        :class="{
          selected: internalModelValue === 'monthly',
          unselected: internalModelValue !== 'monthly',
        }"
      >
        <label>
          <input v-model="internalModelValue" type="radio" name="ratetype" value="monthly" />
          <i class="input-helper"></i>
          {{ $t('Per month') }}
        </label>
      </div>
    </div>

    <div class="tw-flex-grow">
      <div
        v-tooltip:top="
          $t('If you have no idea what to charge for the assignment, you can choose this option.')
        "
        class="radio input-btn"
        :class="{
          selected: internalModelValue === 'unknown',
          unselected: internalModelValue !== 'unknown',
        }"
      >
        <label>
          <input v-model="internalModelValue" type="radio" name="ratetype" value="unknown" />
          <i class="input-helper"></i>
          {{ $t('Not sure') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useVModel } from '@vueuse/core'
import { defineProps } from 'vue'
import { useTranslation } from '@/composables/translation'

const props = defineProps({
  association: {
    type: String,
    required: true,
  },
  market: {
    type: String,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const { $t } = useTranslation()
const internalModelValue = useVModel(props, 'modelValue', emit)
</script>
